module.exports = __webpack_public_path__ + "img/m2.3fbc06e4.png";